import { useContext } from 'react';
import { PermissionsContext } from '../providers/Permissions/Permissions';

export const usePermissions = () => useContext(PermissionsContext);
